import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addCareHomeGroupFailure,
  //
  addCareHomeGroupSuccess,
  deleteCareHomeGroupFailure,
  //
  deleteCareHomeGroupSuccess,
  editCareHomeGroupFailure,
  //
  editCareHomeGroupSuccess,
  fetchCareHomeGroups as fetchCareHomeGroupsAction,
  fetchCareHomeGroupsFailure,
  fetchCareHomeGroupsSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  searchCareHomeFailure,
  //
  searchCareHomeSuccess,
  //
  generateCompanyCodeSuccess,
  generateCompanyCodeFailure,
  //
  generateCompanyAddressSuccess,
  generateCompanyAddressFailure,
  //
  inviteCompanySuccess,
  inviteCompanyFailure,
  directClaimCompanySuccess,
  directClaimCompanyFailure,
} from "./actions";
import {
  ADD_CARE_HOME_GROUP,
  DELETE_CARE_HOME_GROUP,
  EDIT_CARE_HOME_GROUP,
  FETCH_CARE_HOME_GROUPS,
  GET_VIEW_DATA,
  SEARCH_CARE_HOME_GROUP,
  GENERATE_COMPANY_CODE,
  GENERATE_COMPANY_ADDRESS,
  INVITE_COMPANY,
  DIRECT_CLAIM_COMPANY,
} from "./constants";

export function* fetchCareHomeGroupsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/company?${query}`);
    yield put(fetchCareHomeGroupsSuccess(data));
  } catch (e) {
    yield put(fetchCareHomeGroupsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching care home group!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/company/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching care home group!"));
  }
}

export function* addCareHomeGroupSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/company/add`, payload.data);
    if (data) {
      yield put(successAlert("CareHomeGroup added successfully!"));
      yield put(addCareHomeGroupSuccess());
      if (payload?.history) {
        payload.history.push("/d/company");
      }
    }
  } catch (e) {
    yield put(addCareHomeGroupFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editCareHomeGroupSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/company/edit/${payload.id}`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("CareHomeGroup updated successfully!"));
      yield put(editCareHomeGroupSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editCareHomeGroupFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteCareHomeGroupSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/company/${payload}`);
    if (data) {
      yield put(successAlert("CareHomeGroup deleted successfully!"));
      yield put(deleteCareHomeGroupSuccess());
      yield put(fetchCareHomeGroupsAction());
    }
  } catch (e) {
    yield put(deleteCareHomeGroupFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchCareHomeSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/company?${query}`);
    yield put(searchCareHomeSuccess(data));
  } catch (e) {
    yield put(searchCareHomeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while searching care home!"));
  }
}

export function* generateCompanyCodeSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token, null, false, true).post,
      `/api/print-company-code`,
      payload.data,
    );
    if (data) {
      yield put(generateCompanyCodeSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `COMPANY_CODE.pdf`);
      document.body.appendChild(link);
      link.click();
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(generateCompanyCodeFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.response?.error === "string")
      yield put(errorAlert(e?.response?.error));
    else if (e.message === undefined)
      yield put(errorAlert("Something when wrong while downloading CODE PDF!"));
  }
}

export function* generateCompanyAddressSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token, null, false, true).post,
      `/api/print-company-address`,
      payload.data,
    );
    if (data) {
      yield put(generateCompanyAddressSuccess());
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `COMPANY_ADDRESS.pdf`);
      document.body.appendChild(link);
      link.click();
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(generateCompanyAddressFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.response?.error === "string")
      yield put(errorAlert(e?.response?.error));
    else if (e.message === undefined)
      yield put(
        errorAlert("Something when wrong while downloading Adress PDF!"),
      );
  }
}

export function* fetchCareHomeGroupsFlow() {
  yield takeEvery(FETCH_CARE_HOME_GROUPS, fetchCareHomeGroupsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addCareHomeGroupFlow() {
  yield takeEvery(ADD_CARE_HOME_GROUP, addCareHomeGroupSaga);
}
export function* editCareHomeGroupFlow() {
  yield takeEvery(EDIT_CARE_HOME_GROUP, editCareHomeGroupSaga);
}
export function* deleteCareHomeGroupFlow() {
  yield takeEvery(DELETE_CARE_HOME_GROUP, deleteCareHomeGroupSaga);
}
export function* searchCareHomeFlow() {
  yield takeEvery(SEARCH_CARE_HOME_GROUP, searchCareHomeSaga);
}
export function* generateCompanyCodeFlow() {
  yield takeEvery(GENERATE_COMPANY_CODE, generateCompanyCodeSaga);
}
export function* generateCompanyAddressFlow() {
  yield takeEvery(GENERATE_COMPANY_ADDRESS, generateCompanyAddressSaga);
}

export function* inviteCompanySaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/hearth/companies/${payload.companyId}/invite`,
      { email: payload.email },
    );
    if (data) {
      yield put(successAlert("Invitation sent"));
      yield put(inviteCompanySuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(inviteCompanyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while sending invitation!"));
  }
}

export function* inviteCompanyFlow() {
  yield takeEvery(INVITE_COMPANY, inviteCompanySaga);
}

export function* directClaimCompanySaga({ payload, onSuccess }) {
  if (!payload.cqcLocationId) {
    yield put(directClaimCompanyFailure());
    yield put(errorAlert("Add a home to this company before claiming it."));
    return;
  }
  try {
    /* The pre-existing self-serve claim endpoint (billing/claim), not a
       Hearth-specific route. It authenticates with the shared customer API
       key rather than this admin's session token — same as the rest of
       billing/*. */
    const data = yield call(
      api(process.env.REACT_APP_CUSTOMER_API_KEY).post,
      `/api/billing/claim`,
      {
        cqc_location_id: payload.cqcLocationId,
        name: payload.name,
        email: payload.email,
        password: payload.password,
      },
    );
    if (data) {
      yield put(successAlert("Company claimed"));
      yield put(directClaimCompanySuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(directClaimCompanyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while claiming company!"));
  }
}

export function* directClaimCompanyFlow() {
  yield takeEvery(DIRECT_CLAIM_COMPANY, directClaimCompanySaga);
}

export default function* CareHomeGroupsSaga() {
  yield all([
    fetchCareHomeGroupsFlow(),
    addCareHomeGroupFlow(),
    editCareHomeGroupFlow(),
    deleteCareHomeGroupFlow(),
    getViewDataFlow(),
    searchCareHomeFlow(),
    generateCompanyCodeFlow(),
    generateCompanyAddressFlow(),
    inviteCompanyFlow(),
    directClaimCompanyFlow(),
  ]);
}
